import styled from 'styled-components';

export const StyledThumbnailsSidebar = styled.div`
  background-color: ${props => props.theme.themeColors.sidebars.background};
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  height: calc(100% - 145px);
  left: ${props => (props.isOpened ? '0' : `-${props.sidebarWidth}`)};
  overflow-y: auto;
  padding: 1.5rem 2rem;
  position: fixed;
  top: 60px;
  transition: left 0.5s ease;
  width: ${props => props.sidebarWidth};
  z-index: 3000;
`;

export const StyledThumbnail = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 24px;

  > img {
    box-shadow: ${props =>
      props.active
        ? `0px 0px 0px 3px ${props.theme.genericColors.blueBright}`
        : 'none'};
    cursor: pointer;
    display: flex;
    height: auto;
    max-width: 120px;
  }

  > span {
    align-self: center;
    color: ${props =>
      props.active
        ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
        : props.theme.themeColors.sidebars.thumbnails.textColor};
    margin-top: 0.5em;
    text-align: center;
  }
`;
